<template>
  <div class="menu-list__section">
    <span class="typo-lg-bold menu-list__title">나의 이용정보</span>
    <div class="menu-list">
      <template v-for="(item, index) in menuItems">
        <MenuCard
          :key="'card-' + index"
          :icon="item.icon"
          :title="item.title"
          :description="item.description"
          @click="$emit('menu-click', item)"
        />
        <div
          v-if="index < menuItems.length - 1"
          :key="'divider-' + index"
          class="menu-list__divider"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
import MenuCard from '@/components/new/molecules/MenuCard.vue'

export default {
  name: 'MenuList',
  components: {
    MenuCard,
  },
  data: function () {
    return {
      menuItems: [
        {
          id: 1,
          icon: require('@/assets/home/icn_adduser_3d.png'),
          title: '환자 등록',
          description: '서비스 이용을 위한 환자 프로필 생성',
        },
        {
          id: 2,
          icon: require('@/assets/home/icn_folder_3d.png'),
          title: '환자정보 관리',
          description: '배송지, 연락처, 카드정보 수정 및 관리',
        },
        {
          id: 3,
          icon: require('@/assets/home/icn_file_3d.png'),
          title: '이용내역 보기',
          description: '과거 처방전 및 결제 내역 통합 관리',
        },
        {
          id: 4,
          icon: require('@/assets/home/icn_tax_3d.png'),
          title: '연말정산 명세서 보기',
          description: '전년도 물품 구매 내역 확인',
        },
      ],
    }
  },
}
</script>

<style scoped>
.menu-list__section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px;
}

.menu-list__title {
  padding: 0;
}

.menu-list {
  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 12px;
  background: #FFF;
  cursor: pointer;
}

.menu-list__divider {
  width: 100%;
  height: 1px;
  background: #F2F4F6;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MenuList.vue